import React, { useEffect } from "react";
import './Main.css'
import SectionItem from "./SectionItem";
import { FaGitAlt } from 'react-icons/fa';
import { SiAdobephotoshop } from 'react-icons/si';
import { TiHtml5 } from 'react-icons/ti';
import { DiCss3 } from 'react-icons/di';
import { SiJavascript } from 'react-icons/si';
import { FaReact } from 'react-icons/fa';
import { DiGulp } from 'react-icons/di';
import AboutMe from "./AboutMe";
import { useState } from "react";

const Main = () => {    
    const [flashAppear1, setFlashAppear1] = useState(false);
    const [flashAppear2, setFlashAppear2] = useState(false);
    const [flashAppear3, setFlashAppear3] = useState(false);
    const [flashAppear4, setFlashAppear4] = useState(false);
    const [flashAppear5, setFlashAppear5] = useState(false);
    const [flashAppear6, setFlashAppear6] = useState(false);
    const [flashAppear7, setFlashAppear7] = useState(false);

    let interval1 = Math.random().toFixed(4)*40000;
    let interval2 = Math.random().toFixed(4)*40000;
    let interval3 = Math.random().toFixed(4)*40000;
    let interval4 = Math.random().toFixed(4)*40000;
    let interval5 = Math.random().toFixed(4)*40000;
    let interval6 = Math.random().toFixed(4)*40000;
    let interval7 = Math.random().toFixed(4)*40000;

    useEffect(() => {
        setInterval(() => {
            setFlashAppear1(true);            
        }, interval1);        
        
        setInterval(() => {
            setFlashAppear1(false)
        }, interval1+6000)

        setInterval(() => {
            setFlashAppear2(true);            
        }, interval2);        
        
        setInterval(() => {
            setFlashAppear2(false)
        }, interval2+6000)
        
        setInterval(() => {
            setFlashAppear3(true);            
        }, interval3);        
        
        setInterval(() => {
            setFlashAppear3(false)
        }, interval3+6000)

        setInterval(() => {
            setFlashAppear4(true);            
        }, interval4);        
        
        setInterval(() => {
            setFlashAppear4(false)
        }, interval4+6000)

        setInterval(() => {
            setFlashAppear5(true);            
        }, interval5);        
        
        setInterval(() => {
            setFlashAppear5(false)
        }, interval5+6000)

        setInterval(() => {
            setFlashAppear6(true);            
        }, interval6);        
        
        setInterval(() => {
            setFlashAppear6(false)
        }, interval6+6000)

        setInterval(() => {
            setFlashAppear7(true);            
        }, interval7);        
        
        setInterval(() => {
            setFlashAppear7(false)
        }, interval7+6000)
        
      }, []);

    return <>
        <main>
            <section className="section_1">
                <div className="section_1_container">
                    <SectionItem flashAppear={flashAppear1} icon={<FaGitAlt/>} title='Git' text='I have a basic knowledge of VCS (Version control system) to collaborate in team: GitHub repositories, branches etc.'/>
                    <SectionItem flashAppear={flashAppear2} icon={<SiAdobephotoshop/>} title='Photoshop' text='Advanced skills in Photoshop and Figma to complete layouts of any dificulty.'/>
                    <SectionItem flashAppear={flashAppear3} icon={<TiHtml5/>} title='HTML5' text='I use all new stuff in HTML5 in my work: tags, properties, metadata basics, whatever...'/>
                    <SectionItem flashAppear={flashAppear4} icon={<DiCss3/>} title='CSS3' text='CSS3 allows me to create beautiful animations, transitions and filters. Anyway, guys on Youtube are full of ideas. Thank them for ability to steal some :)'/>
                    <SectionItem flashAppear={flashAppear5} icon={<SiJavascript/>} title='Javascript' text='Every frontend developer must know JS, so I am not exeption. I like to use native Javascript, ES6 and ES2022 as well as JS-frameworks.'/>
                    <SectionItem flashAppear={flashAppear6} icon={<FaReact/>} title='React' text='This site was written on React and it`s plugins: react-animations, react-icons, react-owl-carousel, react-router-dom and styled-components. '/>
                    <SectionItem flashAppear={flashAppear7} icon={<DiGulp/>} title='Gulp' text='Okay, if "npm build" is not enough we can use Gulp task manager: code minification, transformation images to Webp, font convertation, autoprefixer etc. '/>
                </div>
            </section>
            <AboutMe />
        </main>
    </>
}

export default Main;